// services/axios.js - FIXED VERSION
import axios from 'axios';

// ✅ PRODUCTION URL (untuk deploy)
const PRODUCTION_API = 'https://toeflproest.cloud/api';

// ✅ DEVELOPMENT URL (untuk local testing)
const DEVELOPMENT_API = 'http://localhost:5000/api';

// ✅ Auto-detect environment
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? PRODUCTION_API 
  : DEVELOPMENT_API;

console.log('🌐 API Base URL:', API_BASE_URL);
console.log('🔧 Environment:', process.env.NODE_ENV);

const instance = axios.create({
  baseURL: API_BASE_URL, // ✅ SUDAH INCLUDE /api
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // ✅ DEBUG: Log setiap request
    console.log('📤 API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      fullURL: config.baseURL + config.url,
      headers: config.headers,
      data: config.data
    });
    
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', {
      status: response.status,
      url: response.config.url,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('❌ API Error:', error.response?.status, error.response?.data);
    
    if (error.response?.status === 401) {
      console.warn('🔒 Unauthorized - clearing auth data');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect ke login jika bukan di halaman login
      if (!window.location.pathname.includes('/login') && 
          !window.location.pathname.includes('/register')) {
        window.location.href = '/';
      }
    }
    
    return Promise.reject(error);
  }
);

export default instance;
